export type QuestionKey = "industry" | "source" | "responder" | "problem" | "revenue" | "role";

export type WizardQuestion = {
  key: QuestionKey;
  question: string;
  options: string[];
};

export type WizardStep = { kind: "question"; question: WizardQuestion } | { kind: "contact" };

const industryQuestion: WizardQuestion = {
  key: "industry",
  question: "¿Qué tipo de negocio tienes?",
  options: [
    "Clínica dental",
    "Veterinaria",
    "Taller mecánico",
    "Landscaping",
    "Otro negocio de servicios",
  ],
};

const sourceQuestion: WizardQuestion = {
  key: "source",
  question: "¿De dónde recibes leads hoy?",
  options: [
    "Facebook",
    "Instagram",
    "Google",
    "Página web",
    "Llamadas o WhatsApp",
    "Referidos",
    "No lo tengo claro",
  ],
};

const responderQuestion: WizardQuestion = {
  key: "responder",
  question: "¿Quién responde tus leads?",
  options: ["Yo como dueño", "Recepción", "Equipo de ventas", "Nadie de forma consistente"],
};

const problemQuestion: WizardQuestion = {
  key: "problem",
  question: "¿Cuál es el mayor problema ahora mismo?",
  options: [
    "Tardamos en responder",
    "No damos seguimiento",
    "No sé qué pasa con los leads",
    "El equipo dice que los leads no sirven",
    "Quiero recuperar contactos viejos",
  ],
};

const revenueQuestion: WizardQuestion = {
  key: "revenue",
  question: "¿Cuánto factura tu negocio al mes?",
  options: ["Menos de $30K", "$30K – $100K", "$100K – $300K", "Más de $300K"],
};

const roleQuestion: WizardQuestion = {
  key: "role",
  question: "¿Cuál es tu rol?",
  options: [
    "Dueño",
    "Director de marketing o ventas",
    "Gerente con poder de decisión",
    "Otro",
  ],
};

/** Progressive capture: contact info comes right after the first question. */
export const wizardSteps: WizardStep[] = [
  { kind: "question", question: industryQuestion },
  { kind: "contact" },
  { kind: "question", question: sourceQuestion },
  { kind: "question", question: responderQuestion },
  { kind: "question", question: problemQuestion },
  { kind: "question", question: revenueQuestion },
  { kind: "question", question: roleQuestion },
];

export const DISQUALIFYING_REVENUE = "Menos de $30K";
export const DISQUALIFYING_ROLE = "Otro";
